<template>
  <section :class="[outer, dividerClass, surfaceClass]">
    <div :class="inner">
      <slot />
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'

type Width = 'narrow' | 'default' | 'wide'
type Padding = 'tight' | 'normal' | 'loose'
type Divider = 'none' | 'top'
type Surface = 'page' | 'alt' | 'dark'

const props = withDefaults(defineProps<{
  width?: Width
  padding?: Padding
  divider?: Divider
  surface?: Surface
}>(), {
  width: 'default',
  padding: 'normal',
  divider: 'none',
  surface: 'page',
})

const paddingMap: Record<Padding, string> = {
  tight:  'py-12',
  normal: 'py-20',
  loose:  'py-28',
}

const surfaceMap: Record<Surface, string> = {
  page: '',
  alt:  'bg-surface-alt',
  dark: 'bg-surface-dark text-cream-50',
}

const outer = computed(() => `w-full overflow-hidden px-6 lg:px-16 ${paddingMap[props.padding]}`)
const surfaceClass = computed(() => surfaceMap[props.surface])

const widthMap: Record<Width, string> = {
  narrow:  'max-w-3xl',
  default: 'max-w-4xl',
  wide:    'max-w-6xl',
}

const inner = computed(() => `${widthMap[props.width]} w-full mx-auto`)

const dividerClass = computed(() =>
  props.divider === 'top' ? 'border-t border-rule' : '',
)
</script>
